import { action as apiAction } from 'api/Api'
import { pushCard } from 'index'

type Payload = {
  cardId: number
  name: string
}

export default (payload: Payload) => async dispatch => {
  const { cardId, name } = payload

  const { Id } = await apiAction('CopyCard', {
    cardId,
    name: name.trim()
  })

  dispatch(pushCard(Id))
}
